<template>
  <modal-window :mainWidth="12">
    <h1>Add a new Special Occurrence</h1>

    <div class="label mt-3 mb-1">Owner Board</div>

    <v-select
      :options="occurrenceStore.possibleOwnerBoards"
      label="title"
      :clearable="false"
      :reduce="(board) => board.id"
      placeholder="Select owner board"
      v-model="occurrence.ownerBoardId"
    ></v-select>

    <div class="label mt-3 mb-1">Type</div>
    <v-select
      :options="availableTypes"
      label="type"
      :clearable="false"
      :reduce="(type) => type"
      placeholder="Please select a occurrence type..."
      v-model="occurrence.type"
    ></v-select>

    <div class="mb-2 mt-3" v-if="occurrence.type !== 'MaterialRequest'">
      <div class="label mt-2 mb-1">Special Occurrence Name</div>
      <input type="text" class="form-control" v-model="occurrence.name" />
    </div>

    <div class="mt-3 d-flex justify-content-between align-content-center">
      <div class="so-btn">
        <button class="btn btn-block btn-sm btn-secondary" @click="cancel()">Cancel</button>
      </div>
      <div class="so-btn">
        <button class="btn btn-block btn-sm btn-success" :disabled="!canAdd" @click="addOccurrence()">
          <i class="far fa-save"></i>
          Add Special Occurrence
        </button>
      </div>
    </div>
  </modal-window>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { SpecialOccurrenceModule, SpecialOccurrenceStore } from '@/store/specialOccurrence';
  import { CreateSpecialOccurrenceDto, SpecialOccurrenceTypeDto } from '@/apiclient/apiclient_generated';
  import ModalWindow from '@/components/ModalWindow.vue';
  import { systemSettingsClient } from '@/apiclient/opsboardapi';

  @Component({
    components: { ModalWindow },
  })
  export default class AddSpecialOccurrence extends Vue {
    private occurrenceStore: SpecialOccurrenceModule = SpecialOccurrenceStore;
    private isSaving = false;
    private occurrence = new CreateSpecialOccurrenceDto({
      name: '',
      type: SpecialOccurrenceTypeDto.Comat,
    });

    materialRequestIsEnabled = false;

    async mounted() {
      await this.occurrenceStore.loadPossibleOwnerBoards();
      this.materialRequestIsEnabled = await systemSettingsClient.getIsMaterialRequestEnabled();

      //set owner board to first board if we only have one
      if (this.occurrenceStore.possibleOwnerBoards.length == 1) {
        this.occurrence.ownerBoardId = this.occurrenceStore.possibleOwnerBoards[0].id;
      }
    }

    get canAdd() {
      if (this.occurrence.type == 'MaterialRequest') {
        if (!this.isSaving && this.occurrence.type && this.occurrence.ownerBoardId) return true;
      } else {
        if (!this.isSaving && this.occurrence.name && this.occurrence.type && this.occurrence.ownerBoardId) return true;
      }

      return false;
    }

    get availableTypes() {
      if (this.materialRequestIsEnabled) {
        return [
          SpecialOccurrenceTypeDto.Comat,
          SpecialOccurrenceTypeDto.TechnicalOccurrence,
          SpecialOccurrenceTypeDto.Diversion,
          SpecialOccurrenceTypeDto.MaterialRequest,
        ];
      } else {
        return [SpecialOccurrenceTypeDto.Comat, SpecialOccurrenceTypeDto.TechnicalOccurrence, SpecialOccurrenceTypeDto.Diversion];
      }
    }

    async addOccurrence() {
      this.isSaving = true;
      const newOcc = await this.occurrenceStore.create(this.occurrence);
      await this.$router.push({ name: 'special-occurrence', params: { occId: newOcc.id } });
    }

    cancel() {
      this.$bvModal.hide('newSpecialOccurrence');
    }
  }
</script>

<style scoped lang="scss">
  .so-btn {
    width: 49%;
  }
</style>
